module.exports = __webpack_public_path__ + "static/img/windowsImg.a05edd2.png";